import { createContext } from 'react'

import { MODE } from '~/shared/components/DarkMode/constants.ts'

interface DarkModeContextType {
  mode: MODE,
  isDark: () => boolean,
  isSystem: () => boolean,
  setMode: (mode: MODE) => void,
  setLocalMode: (mode: MODE) => void,
}

export const DarkModeContext = createContext<DarkModeContextType | undefined>(undefined)